(function (angular) {
    angular.module('app.errors', []);

    angular.module('app.errors').run(['$rootScope', '$state', function ($rootScope, $state) {
        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            event.preventDefault();
            $state.go('error', { error: error });
        });
    }]);

    angular.module('app.errors').config(['$stateProvider', function ($stateProvider) {

        $stateProvider.state('not-found', {
            url: '/not-found',
            templateUrl: '/app/errors/not-found.html'
        });

        $stateProvider.state('error', {
            url: '/error',
            templateUrl: '/app/errors/error.html',
            params: {
                error: null
            },
            controller : ['$scope', '$stateParams', function($scope, $stateParams) {
                $scope.error = $stateParams.error;
            }]
        });

        $stateProvider.state('unauthorized', {
            url: '/unauthorized',
            templateUrl: '/app/errors/unauthorized.html'
        });

        $stateProvider.state('under-construction', {
            url: '/under-construction',
            templateUrl: '/app/errors/under-construction.html',
            controller: 'app.under-construction.controller',
            controllerAs: 'vmConstruction',
            resolve: {
                previousState: ["$state", function previousState($state) {
                    var currentStateData = {
                        name: $state.current.name,
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });

    }]);

}(angular));

